/* eslint-disable @typescript-eslint/camelcase */
import { extend } from 'vee-validate';
import { cpf, cnpj } from 'cpf-cnpj-validator';
import {
  required, integer, max_value, min_value, min, alpha_spaces, email,
} from 'vee-validate/dist/rules';
import { validCep } from '@/utils';

extend('requiredInput', {
  ...required,
  message: (field) => `O campo ${field} é obrigatório`,
});

extend('emailInput', {
  ...email,
  message: (field) => `O campo ${field} não é válido`,
});

extend('requiredQuestion', {
  ...required,
  message: (field) => `Questão ${field} é obrigatório`,

});

extend('validateDocument', {
  validate: (value) => cpf.isValid(value) || cnpj.isValid(value),
  message: (field) => `O campo ${field} não é válido`,
});

extend('integer', {
  ...integer,
  message: (field) => `O campo ${field} aceita apenas número inteiros`,
});

extend('alpha_spaces', {
  ...alpha_spaces,
  message: (field) => `O campo ${field} aceita apenas caracteres alfabéticos e espaços`,
});

extend('maxValue', {
  ...max_value,
  message: (field, args) => {
    return `O campo ${field} ter no máximo ${args.max}`;
  },
});

extend('minValue', {
  ...min_value,
  message: (field, args) => {
    return `O campo ${field} deve ter no mínimo ${args.min} caracteres`;
  },
});

extend('checkCep', {
  validate: (field) => validCep(field).then((data) => data.isValid),
  message: (field) => `O campo ${field} não é válido`,
});

extend('min', {
  ...min,
  message: (field, args) => {
    return `O campo ${field} deve ter no mínimo ${args.length} caracteres`;
  },
});
